module.exports = __webpack_public_path__ + "img/menu-store-1.9dbabde4.jpg";